export enum FileType {
    profile_picture = 'profile_picture',
}
